import React, { useState, useEffect } from "react";
import { Modal, Spinner } from "react-bootstrap";
import { useLocation, useNavigate } from "react-router-dom";
import MekhrazeemRep from "./MekhrazeemRep";
import MoamadeemRep from "./MoamadeemRep";
import MoamadRep from "./MoamadRep";
import MyJustDate from "../shared/MyJustDate";
import MoamadRepByDate from "./MoamadRepByDate";
import MoamadExtentionDateRep from "./MoamadExtentionDateRep";
import MoamadDocumentInExtentionDateRep from "./MoamadDocumentInExtentionDateRep";
import MemberRep from "./MemberRep";
import HandleHttpErrors from "../HandleHttpErrors";
import useAxiosPrivate from "../../hooks/useAxiosPrivate";
import * as XLSX from "xlsx";

const baseURL = process.env.REACT_APP_API;
const exportToExcel = (data) => {
  const formattedData = data.map((item) => ({
    "מספר המכרז": item.mkh_num,
    תאור: item.title,
    // סוג: item.mkh_type,
    סוג: item.mkh_type_display,
    "האם בוטל": item.canceled ? "כן" : "לא",
    "תאריך פרסום": item.persom_date,
    "תאריך הגשה": item.hagsha_date,
    //מחלקה: item.department,
    מחלקה: item.department_title,
    "מספר משרות": item.mesrot_num,
    "אחוז המשרה": item.ahoz_mesra,
    "מספר המועמדים": item.total_moamad,
    "מספר שעמדו בתנאי הסף": item.saf_true_count,
  }));
  const worksheet = XLSX.utils.json_to_sheet(formattedData);
  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");

  // Generate Excel file and download it
  XLSX.writeFile(workbook, "mekhraz-report.xlsx");
};

const Reports = () => {
  // State to track the selected radio button
  const [proposalStatus, setProposalStatus] = useState(null);
  const [selectedOption, setSelectedOption] = useState("");
  const [pageNumberDates, setPageNumberDates] = useState("1");
  const [showDefineReport, setShowDefineReport] = useState(false);
  const [departments, setDepartments] = useState([]);
  const [mekhrazCondetionRep, setMekhrazCondetionRep] = useState([]);
  const [loading, setLoading] = useState(true);
  const location = useLocation();
  const navigate = useNavigate();
  const [conditions, setConditions] = useState({
    fromDate: null,
    toDate: null,
    department: 0,
    mkhType: "N", // There is no limitation about mekhraz type
    cancelled: "noLimit",
  });
  const axiosPrivate = useAxiosPrivate("application/json");
  useEffect(() => {
    const getProposalStatus = async () => {
      const now = MyJustDate(new Date());
      const response = await axiosPrivate
        .get(baseURL + "jobs/genparams")
        .then((response) => {
          setProposalStatus(response.data[0].proposal_status);
        });
    };
    getProposalStatus();
  }, []);
  useEffect(() => {
    let isMounted = true;
    const controller = new AbortController();

    const today = new Date();
    // Set time to midnight to avoid timezone issues
    today.setHours(0, 0, 0, 0);

    // First day of the current month
    const firstOfMonth = new Date(today.getFullYear(), today.getMonth(), 2);

    setConditions((prevConditions) => ({
      ...prevConditions,
      fromDate: firstOfMonth.toISOString().split("T")[0], // YYYY-MM-DD format
      toDate: today.toISOString().split("T")[0], // YYYY-MM-DD format
    }));

    const getDepartments = async () => {
      try {
        const response = await axiosPrivate.get(baseURL + "jobs/department/", {
          signal: controller.signal,
        });
        isMounted && setDepartments(response.data);
        setLoading(false);
      } catch (err) {
        console.error(err);
        navigate("/login", { state: { from: location }, replace: true });
      }
    };
    getDepartments();

    return () => {
      isMounted = false;
      isMounted && controller.abort();
    };
  }, []);

  useEffect(() => {
    document.body.classList.add("accountBodyColor");
    // Clean up function to remove the class when the component unmounts
    return () => {
      document.body.classList.remove("accountBodyColor");
    };
  }, []);
  // Handler function to update the selected option
  const handleOptionChange = (event) => {
    setSelectedOption(event.target.value);
  };

  const handleChange = (e) => {
    e.preventDefault(); // prevent the default action
    const { name, value } = e.target;
    setConditions((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  const handleMekhrazConditionRep = (e) => {
    let isMounted = true;
    const controller = new AbortController();
    setLoading(true);

    const getMekhrazConditionRep = async () => {
      try {
        const response = await axiosPrivate.get(
          baseURL +
            "jobs/meckrazconditionsrep/?fromdate=" +
            conditions.fromDate +
            "&todate=" +
            conditions.toDate +
            "&department=" +
            conditions.department +
            "&mkhtype=" +
            conditions.mkhType +
            "&cancelled=" +
            conditions.cancelled,
          {
            signal: controller.signal,
          }
        );
        if (isMounted) {
          setMekhrazCondetionRep(response.data);
          if (response.data.length > 0) {
            exportToExcel(response.data);
          } else {
            alert("לא קיימים מכרזים בהתאם לתנאים.");
          }
        }
      } catch (err) {
        if (err.response) {
          alert(HandleHttpErrors(err.response.status));
        } else if (err.request) {
          alert(
            " The client never received a response, and the request was never left"
          );
          console.log(err.request);
        } else {
          alert(" Anything else");
        }
      }
    };
    getMekhrazConditionRep();
    setLoading(false);
  };
  if (loading) {
    return (
      <div
        className="d-flex justify-content-center align-items-center"
        style={{ height: "100vh" }}
      >
        <div className="text-center">
          <Spinner animation="border" variant="secondary" visible />

          <br />
          <br />
          <h3 className="spinnerText">המתן עד סיום הפעולה.</h3>
        </div>
      </div>
    );
  } else {
    return (
      <>
        <Modal show={showDefineReport} backdrop="static" keyboard={false}>
          <Modal.Header style={{ textAlign: "center" }}>
            <Modal.Title>{"הגדר דוח מכרזים"}</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div
              className="form-group"
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
              }}
            >
              <div
                className="form-group"
                style={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                }}
              >
                <label htmlFor="fromDate" className="required-label blue-text">
                  מתאריך פרסום
                </label>
                <input
                  type="date"
                  name="fromDate"
                  value={conditions.fromDate}
                  onChange={handleChange}
                  className="form-control"
                  id="fromDate"
                  placeholder=""
                  required
                />
              </div>
              <div
                className="form-group"
                style={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                }}
              >
                <label htmlFor="toDate" className="required-label blue-text">
                  עד תאריך פרסום
                </label>
                <input
                  type="date"
                  name="toDate"
                  value={conditions.toDate}
                  onChange={handleChange}
                  className="form-control"
                  id="toDate"
                  placeholder=""
                  required
                />
              </div>
              <div
                className="form-group"
                style={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                }}
              >
                <label htmlFor="mkhType" className="required-label blue-text">
                  מחלקה
                </label>

                <select
                  name="department"
                  onChange={handleChange}
                  value={conditions.department}
                  required
                >
                  <option value="" selected>
                    בחר מחלקה
                  </option>
                  {departments?.map((d) => (
                    <option key={d.id} value={d.id}>
                      {d.title}
                    </option>
                  ))}
                </select>
              </div>

              <div
                className="form-group"
                style={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                }}
              >
                <label htmlFor="mkhType" className="required-label blue-text">
                  סוג מכרז
                </label>
                <select
                  name="mkhType"
                  onChange={handleChange}
                  value={conditions.mkhType}
                  required
                  autoComplete="off"
                >
                  <option key="0" value="N" selected>
                    אין הגבלה
                  </option>
                  <option key="1" value="O" selected>
                    פומבי
                  </option>
                  <option key="2" value="I" selected>
                    פנימי
                  </option>
                  <option key="3" value="T" selected>
                    פטור
                  </option>
                </select>
              </div>

              <div
                className="form-group"
                style={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                }}
              >
                <label htmlFor="toDate" className="required-label blue-text">
                  האם המכרז בוטל?
                </label>
              </div>
              <div>
                <label
                  className="radio-label"
                  style={{
                    color: "black",
                    position: "relative",
                  }}
                >
                  <input
                    type="radio"
                    name="cancelled"
                    value="noLimit"
                    checked={conditions.cancelled === "noLimit"}
                    onChange={handleChange}
                    style={{ marginLeft: "10px" }}
                  />
                  ללא הגבלה
                </label>

                <label className="radio-label" style={{ color: "black" }}>
                  <input
                    type="radio"
                    name="cancelled"
                    value="active"
                    checked={conditions.cancelled === "active"}
                    onChange={handleChange}
                    style={{ marginLeft: "10px" }}
                  />
                  לא
                </label>
                <label className="radio-label" style={{ color: "black" }}>
                  <input
                    type="radio"
                    name="cancelled"
                    value="cancelled"
                    checked={conditions.cancelled === "cancelled"}
                    onChange={handleChange}
                    style={{ marginLeft: "10px" }}
                  />
                  כן
                </label>
              </div>
            </div>
          </Modal.Body>
          <Modal.Footer
            style={{ display: "flex", justifyContent: "space-between" }}
          >
            <button
              className="btn btn-secondary"
              onClick={(event) => {
                handleMekhrazConditionRep(event);
                setShowDefineReport(false);
              }}
              style={{ marginLeft: "auto" }} // Pushes the button to the right
            >
              יצא דוח לאקסל
            </button>
            <button
              className="btn btn-secondary"
              onClick={() => {
                setShowDefineReport(false);
              }}
              style={{ marginRight: "auto" }} // Pushes the button to the left
            >
              בטל
            </button>
          </Modal.Footer>
        </Modal>
        <div>
          <center>
            <div className="container-fluid">
              <div className="row">
                <div className="col-12 col-md-3 ">
                  <button
                    value="מכרזים"
                    onClick={handleOptionChange}
                    className="btn btn-secondary w-100"
                  >
                    -סטטיסטיקה - מכרזים
                  </button>
                </div>
                <div className="col-12 col-md-3 ">
                  <button
                    value="מועמדים"
                    onClick={handleOptionChange}
                    className="btn btn-secondary w-100"
                  >
                    -סטטיסטיקה - מועמדים
                  </button>
                </div>
                <div className="col-12 col-md-3">
                  <button
                    value="מועמד"
                    onClick={handleOptionChange}
                    className="btn btn-secondary w-100"
                  >
                    -דוחות - מועמד
                  </button>
                </div>
                <div className="col-12 col-md-3 ">
                  <button
                    value="הגשות"
                    onClick={handleOptionChange}
                    className="btn btn-secondary w-100"
                  >
                    הגשות לפי תאריך
                  </button>
                </div>
                <div className="col-12 col-md-3 ">
                  <button
                    value="הארכת מועד הגשה"
                    onClick={handleOptionChange}
                    className="btn btn-secondary w-100"
                  >
                    הארכת מועד הגשת מסמכים למועמדים
                  </button>
                </div>
                <div className="col-12 col-md-3 ">
                  <button
                    value="מסמכים שהוגשו בעקבות הארכה"
                    onClick={handleOptionChange}
                    className="btn btn-secondary w-100"
                  >
                    מסמכים שהוגשו בעקבות הארכה
                  </button>
                </div>
                <div className="col-12 col-md-3 ">
                  <button
                    value="חברים"
                    onClick={handleOptionChange}
                    className="btn btn-secondary w-100"
                  >
                    דו"ח השתפפות חברים בישיבות
                  </button>
                </div>

                <div className="col-12 col-md-3 ">
                  <button
                    onClick={() => setShowDefineReport(true)}
                    className="btn btn-danger w-100"
                  >
                    יצוא דוח מכרזים לפי תנאים לאקסל
                  </button>
                </div>
              </div>
            </div>

            <hr />
          </center>
          {selectedOption === "מכרזים" && <MekhrazeemRep />}
          {selectedOption === "מועמדים" && <MoamadeemRep />}
          {selectedOption === "מועמד" && proposalStatus !== null && (
            <MoamadRep proposalStatus={proposalStatus} />
          )}
          {selectedOption === "חברים" && <MemberRep />}
          {selectedOption === "הארכת מועד הגשה" && proposalStatus !== null && (
            <MoamadExtentionDateRep proposalStatus={proposalStatus} />
          )}
          {selectedOption === "מסמכים שהוגשו בעקבות הארכה" &&
            proposalStatus !== null && (
              <MoamadDocumentInExtentionDateRep
                proposalStatus={proposalStatus}
              />
            )}
          {selectedOption === "הגשות" && proposalStatus !== null && (
            <MoamadRepByDate
              pageNumber={pageNumberDates}
              setPageNumber={setPageNumberDates}
              proposalStatus={proposalStatus}
            />
          )}
        </div>
      </>
    );
  }
};

export default Reports;
